import { useMutation } from '@tanstack/react-query'
import { loginFetch } from 'store/middlewares/auth.crud'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { loginHooks } from '..'

const useLogin = () => {
    const setUserData = loginHooks.useSetUserData()

    const { mutateAsync: loginUser, isPending: loading, error } = useMutation({
        mutationFn: loginFetch,
        onSuccess: (res) => {
            setUserData(res.data)
        },
        onError: (error) => {
            const { response } = error
            if (response.status === 401) {
                toast.error("שם משתמש או סיסמה שגוי", toastConfig);
            }
            else if (response.status === 400) {

            }
            else if (response.status === 403) {
                toast.error("אנחנו מצטערים, כרגע אין לכם גישה למערכת", toastConfig)
                return error
            }
            else toast.error("שגיאה, נסה שוב מאוחר יותר", toastConfig);

            return error
        }
    })

    const login = async (values) => {
        await loginUser(values)
    }

    return {
        login,
        loading
    }
}

export default useLogin